export const analysis = {
  analysis: {
    analysisCard: {
      analysisActions: 'Analysis actions',
      cancel: 'Cancel',
      delete: 'Delete',
      areYouSureYouWantToDelete:
        'Are you sure you want to delete "{{name}}"? This action cannot be undone. The analysis and all associated data will be permanently removed.',
      deleteAnalysis: 'Delete Analysis',
      deleting: 'Deleting...',
      failedToGenerate: 'Failed to generate',
      generating: 'Generating...',
      retry: 'Retry',
    },
    analysisCardV2: {
      completed: 'Completed',
      deleteReport: 'Delete report',
      failed: 'Failed',
      generating: 'Generating',
      openReport: '{{title}}, {{status}}',
      retryAnalysis: 'Retry analysis',
    },
    analysisEmptyState: {
      newIQ: 'New IQ',
      noIqAnalysesGenerated: 'No IQ analyses generated',
      startCreatingYourNewAnalysis:
        'Start creating your new analysis by clicking on the button below',
    },
    analysisListContent: {
      anErrorOccurredAndThe:
        'An error occurred and the data could not be loaded. Please try refreshing the page.',
      clearFilters: 'Clear filters',
      dataFailedToLoad: 'Data failed to load',
      name: 'Name',
      newIQ: 'New IQ',
      newestFirst: 'Newest first',
      noAnalysesMatchYourCurrent: 'No analyses match your current search or filters.',
      noMatchingAnalyses: 'No matching analyses',
      oldestFirst: 'Oldest first',
      search: 'Search by title or description...',
      searchLabel: 'Search by title or description',
    },
    analysisNotifications: {
      analysisComplete: 'Analysis complete',
      analysisGenerationStarted: 'Analysis generation started',
      dismiss: 'Dismiss',
      readyToView: 'Your analysis for "{{analysisName}}" is ready to view.',
      thisMayTakeUpTo: "This may take up to 60 minutes. We'll notify you once it's ready",
    },
    analysisSidebar: {
      audienceProfiles: 'Audience Profiles',
      brandXRay: 'Brand X-Ray',
      businessChallenge: 'Business Challenge',
      businessOpportunities: 'Business Opportunities',
      categories: 'Categories',
      categoryCompetition: 'Category & Competition',
      closeNavigation: 'Close navigation',
      creativeLandscape: 'Creative Landscape',
      cultureContext: 'Culture & Context',
      executiveSnapshot: 'Executive Snapshot',
      marketingPerformance: 'Marketing Performance',
      mediaLandscape: 'Media Landscape',
      noAnalysesFound: 'No analyses found',
      sectionNavigation: 'Analysis sections',
      selectAnalysis: 'Select analysis',
      viewNavigation: 'View navigation',
    },
    analysisTable: {
      actions: 'Actions',
      completed: 'Completed',
      created: 'Created',
      deleteReport: 'Delete report',
      failed: 'Failed',
      generating: 'Generating',
      report: 'Report',
      retryAnalysis: 'Retry analysis',
      status: 'Status',
    },
    audienceStep: {
      pickExistingAudiencesOrAdd: 'Pick existing audiences or add new ones in the Knowledge Hub',
      whatSYourAudience: "What's your audience?",
    },
    audienceStepV2: {
      audience: 'Audience',
      defineMyOwnAudience: 'Define my own audience',
      fromKnowledgeHub: 'From Knowledge hub',
      iqIsStillReading:
        'IQ is still reading your documents. Switching stops it, and the audiences it was about to find will be lost. The documents themselves are untouched, and you can upload them again.',
      keepEditing: 'Keep editing',
      startFromTheOtherSource: 'Start from the other source?',
      switchAndClear: 'Switch and clear',
      theAudiencesReadFrom:
        'The audiences read from your document will be cleared. The document itself is untouched, and you can upload it again.',
      theAudiencesYouPicked: 'The audiences you picked from the Knowledge hub will be cleared.',
      handPickAudiencesFromThe: 'Hand-pick audiences from the Knowledge hub.',
      iqRunsDeepResearch:
        "IQ runs deep research against this report's goal and creates new audience segments for you.",
      letIqSuggestMyAudience: 'Let IQ suggest my audience',
      uploadDocument: 'Upload document',
      whoThisReportShouldFocus:
        'Who this report should focus on. You can change your approach at any time.',
    },
    analysisModels: {
      geminiDeepResearchHint: 'Standard - deeper, slower',
      geminiDeepResearchLabel: 'Gemini Deep Research',
      openaiGpt56SolHint: 'Fewer sources, faster turnaround',
      openaiGpt56SolLabel: 'OpenAI GPT-5.6 Sol',
    },
    brandGoalStep: {
      analysisGoal: 'Analysis goal',
      brandProductName: 'Brand/product name',
      brandWebsite: 'Brand website',
      deepResearchModel: 'Deep research model',
      defineTheBrandAndDescribe: 'Define the brand and describe the goal of this analysis',
      eGUnderstandOurCompetitive:
        'e.g. Understand our competitive position in the digital marketing space and identify growth opportunities...',
      eGWwwBrandnameCom: 'e.g. www.brandname.com',
      enterName: 'Enter name',
      removeMarket: 'Remove {{market}}',
      targetMarkets: 'Target markets',
      typeAndHitEnterTo: 'Type and hit enter to add multiple markets',
      whatSTheGoalOf: "What's the goal of this analysis?",
    },
    brandGoalStepV2: {
      add: 'Add',
      aiModel: 'AI model',
      atMostNWebsites_one: 'At most {{count}} website.',
      atMostNWebsites_other: 'At most {{count}} websites.',
      allUrlsWithInformation:
        'All URLs with information relevant about the brand that IQ should be aware of.',
      brandName: 'Brand name',
      brandWebsites: 'Brand websites',
      chooseModel: 'Choose model',
      describeYourGoal: 'Describe your goal',
      eGQ3BrandHealth: 'e.g: Q3 brand health',
      eGUnitedStates: 'e.g: United States',
      enterAFullUrl: 'Enter a website address starting with http://, https:// or www.',
      enterBrand: 'Enter brand',
      httpsYourbrandwebsiteCom: 'https://yourbrandwebsite.com',
      leaveBlankAndTheBrand: 'Leave blank and the brand name is used.',
      removeWebsite: 'Remove {{website}}',
      reportGoal: 'Report goal',
      reportName: 'Report name',
      selectTheMarket: 'Select the market this IQ should address.',
      selectTheModelUsed:
        'Select the model used to generate the IQ report. Play with different models to experiment different results.',
      setTheGoalBrandAndTarget: 'Set the goal, brand and target market.',
      targetMarket: 'Target market',
      theBrandOrProduct: 'The brand or product this report analyzes.',
      whatThisIqIsFor: 'What this IQ is for and to who?',
    },
    analysisProviders: {
      geminiLabel: 'Gemini',
      openaiLabel: 'OpenAI',
    },
    competitorCreateManuallyTab: {
      addCompetitor: 'Add competitor',
      competitor: 'Competitor',
      describeTheCompetitorSMarket:
        "Describe the competitor's market position, key products, and competitive advantages...",
      eGNikeAdidasPuma: 'e.g., Nike, Adidas, Puma',
    },
    competitorsStep: {
      createManually: 'Create manually',
      howWouldYouLikeTo: 'How would you like to define your competitors?',
      iLlDefineMyOwn: "I'll define my own competitors",
      letIqDefineItFor: 'Let IQ define it for you or define your own competitors',
      letIqDefineMyCompetitors: 'Let IQ define my competitors',
      ourAiWillResearchYour:
        'Our AI will research your market and identify the most relevant competitors',
      provideYourOwnCompetitorList:
        'Provide your own competitor list for a more targeted competitive analysis',
      uploadDocument: 'Upload document',
    },
    competitorsStepV2: {
      addTheExactSet: 'Add the exact set of brands you want this report to benchmark against.',
      competitors: 'Competitors',
      defineMyOwnCompetitors: 'Define my own competitors',
      iqRunsDeepResearch:
        "IQ runs deep research against this report's goal and market to identify the relevant competitors for you.",
      letIqSuggestCompetitors: 'Let IQ suggest competitors',
      whichBrandsToBenchmark:
        'Which brands to benchmark against. You can change your approach at any time.',
    },
    extractFromDocumentTab: {
      dropDocumentsHere: 'Drop documents here',
      pdfDocDocxTxtRtf: 'PDF, DOC, DOCX, TXT, RTF (max 10MB)',
    },
    iqanalysisPreview: {
      allAnalysis: 'All analysis',
      createdAt: 'Created at',
      createdBy: 'Created by',
      iqAnalysis: 'IQ analysis',
      name: 'Name',
      noAnalysesYet: 'No analyses yet',
      recentIqAnalysis: 'Recent IQ analysis',
      unknownCreator: 'Unknown',
    },
    knowledgeHubAudiencePicker: {
      added: 'Added {{date}}',
      addOneInTheKnowledgeHub: 'Add one in the <hubLink>Knowledge hub</hubLink> to pick it here.',
      nAudiencesSelected_one: '{{count}} audience selected',
      nAudiencesSelected_other: '{{count}} audiences selected',
      newestFirst: 'Newest first',
      noAudiencesMatch:
        'No audiences match — try a broader term, or let IQ suggest audiences instead.',
      noAudiencesYet: 'No audiences yet',
      oldestFirst: 'Oldest first',
      searchAudiences: 'Search audiences',
      searchByNameTraitOrTag: 'Search by name, trait, or tag',
      unknownSegment: 'Unknown segment',
    },
    sourcePanel: {
      close: 'Close source',
      description: 'Description',
      kind: {
        forecast: 'Market forecast',
        statistic: 'Measured statistic',
        survey: 'Consumer survey',
      },
      openSource: 'Open source',
      statista: 'Statista',
      title: 'Source',
      viewSource: 'View source',
      viewSourceNumber: 'View source {{number}}',
    },
    uploadDocumentTab: {
      atMostNAudiences_one: 'A report takes at most {{count}} audience from your documents.',
      atMostNAudiences_other: 'A report takes at most {{count}} audiences from your documents.',
      browseFiles: 'Browse files',
      chooseDocuments: 'Choose documents',
      couldNotReadThe: 'Could not read the documents',
      extractingAudiencesFrom: 'Extracting audiences from {{files}}...',
      iqReadsItAndExtracts:
        'IQ reads it and extracts the audience segments - PDF, DOCX, PPTX, XLSX, TXT or MD.',
      iqReadsUpToN:
        'IQ reads up to {{max}} documents at a time, and you chose {{picked}}. Pick fewer, or add the rest with Upload another.',
      thoseDocumentsComeTo:
        'Those documents come to {{picked}}, and IQ reads up to {{max}} at a time. Pick fewer, or add the rest with Upload another.',
      noAudiencesInThe:
        'No audiences in there. Try a document that describes who the report is for.',
      nSegmentsExtracted_one: '{{files}} - {{count}} segment extracted',
      nSegmentsExtracted_other: '{{files}} - {{count}} segments extracted',
      nSegmentsFound_one: '{{count}} segment extracted',
      nSegmentsFound_other: '{{count}} segments extracted',
      saveThisSegmentToThe: 'Save this segment to the Knowledge hub for reuse',
      theReadStopped: 'The read stopped responding. Trying again picks the same documents back up.',
      tryAgain: 'Try again',
      uploadAnAudienceDocument: 'Upload an audience document',
      uploadAnother: 'Upload another',
      uploadingFiles: 'Uploading {{files}}...',
      whatEarlierDocumentsGave_one: 'The {{count}} audience from your earlier document is kept.',
      whatEarlierDocumentsGave_other:
        'The {{count}} audiences from your earlier documents are kept.',
    },
    manualEntryCard: {
      entityDetails: '{{label}} details',
      entityHeading: '{{label}} {{index}}',
      entityName: '{{label}} name',
      removeEntity: 'Remove {{label}} {{index}}',
    },
    sectionUnavailable: {
      title: 'No {{category}} data available',
      body: '{{category}} data is not yet available for this analysis.',
    },
    selectFromKnowledgeTab: {
      clearSearch: 'Clear search',
      goToAudiences: 'Go to audiences',
      inTheKnowledgeToAdd: 'in the knowledge to add audiences',
      noAudiencesToDisplay: 'No audiences to display',
      removeAudience: 'Remove {{name}}',
      searchAudiences: 'Search audiences...',
      unknownSegment: 'Unknown Segment',
    },
    useAnalyses: {
      analysisDeleted: 'Analysis deleted',
      analysisGenerationRestarted: 'Analysis generation restarted',
      failedToCreateAnalysis: 'Failed to create analysis',
      failedToDeleteAnalysis: 'Failed to delete analysis',
      failedToRetryAnalysis: 'Failed to retry analysis',
      failedToSaveAnalysis: 'Failed to save analysis',
    },
    viewToggle: {
      grid: 'Grid',
      gridView: 'Grid view',
      list: 'List',
      listView: 'List view',
    },
  },
  analysisHome: {
    about: {
      buildTheCase: 'Build the case for your next move with evidence behind it.',
      clearFindings: 'Move from raw research to clear findings without the manual analysis.',
      spotPatterns: 'Spot patterns and opportunities across your audience data.',
      title: 'About IQ',
    },
    turnAudienceResearchIntoInsights:
      'Turn audience research into insights and analysis you can act on.',
  },
  dataSourcesPanel: {
    title: 'Data sources',
    open: 'Data sources',
    close: 'Close data sources',
    back: 'Back to data sources',
    availableTitle: 'Available data sources',
    availableSubtitle: 'Select a source to attach a file',
    badgeAttached: 'Attached',
    badgeAvailable: 'Available',
    uploadTitle: 'Upload {{name}} data',
    templateTitle: 'Start from the sample template',
    templateBody:
      "Your file must match the template's column names. If the format differs, the report cannot read the data.",
    templateDownload: 'Download template',
    templateFailed: 'Could not download the template',
    fileInput: 'Choose a CSV or XLSX file',
    dropzoneAction: 'Click to upload',
    dropzoneHint: 'or drag and drop',
    dropzoneFormats: 'CSV or XLSX, up to {{size}}',
    uploading: 'Reading {{name}}',
    uploadFailedTitle: "We couldn't read {{name}}",
    rejectedType: 'Only CSV and XLSX files can be attached.',
    rejectedSize: 'That file is larger than the {{size}} limit.',
    uploadFailedFallback: 'Check that the file matches the template and try again.',
    dismissError: 'Dismiss error',
    attachedTitle: 'Attached file',
    attachedSubtitle: 'The file powering this data source',
    attachedMeta: '{{size}} · Uploaded {{date}}',
    attachedRows_one: '{{count}} row',
    attachedRows_other: '{{count}} rows',
    download: 'Download file',
    downloadUnavailable:
      'This file was attached before uploads were stored, so it cannot be downloaded',
    downloadFailed: 'Could not download the file',
    remove: 'Remove file',
    removeTitle: 'Remove {{name}} data?',
    removeDescription:
      'The report sections built from this file will go back to their empty state. You can upload a new file at any time.',
    removeConfirm: 'Remove',
    removeFailed: 'Could not remove the file',
    replaceTitle: 'Replace the {{name}} file?',
    replaceDescription:
      'A data source holds one file. Uploading {{filename}} replaces the file attached now, and the report sections rebuild from it.',
    replaceConfirm: 'Replace',
    cancel: 'Cancel',
    empty: 'No data sources are connected. An admin can connect them from Knowledge.',
  },
  analysisResult: {
    adjacentAudiences: {
      adjacentAudiences: 'Adjacent Audiences',
      contentComingSoon: 'Content coming soon...',
      reachablePoolsOutsideTheSubscriberBase: 'Reachable pools outside the current subscriber base',
    },
    analysisResult: {
      analysis: 'analysis',
      iq: 'IQ',
    },
    analysisAddToProjectButton: {
      addToProject: 'Add to project',
    },
    analysisStartBriefButton: {
      artifactFallbackName: 'IQ analysis',
      startBrief: 'Start brief',
    },
    analysisDownloadButton: {
      downloadReport: 'Download',
      failedToDownloadReport: 'Failed to download report',
      fileNameFallback: 'analysis',
      preparingYourDownload: 'Preparing your download, this may take a moment…',
    },
    audienceProfiles: {
      allAudienceProfiles: 'All audience profiles',
      audienceProfiles: 'Audience Profiles',
      coreSegmentsCommunitiesAdjacencies: '{{brandName}} Core Segments, Communities & Adjacencies',
    },
    brandIdentity: {
      logoAlt: '{{brand}} logo',
    },
    brandXray: {
      brandXRay: 'Brand X-Ray',
      deepCulturalAnalysis: '{{brandName}} Deep Cultural Analysis',
    },
    breakthroughOpportunities: {
      breakthroughOpportunities: 'Breakthrough Opportunities',
      culture: 'Culture',
      keyAreasForInnovationAnd: 'Key areas for innovation and competitive advantage',
      regulation: 'Regulation',
      sustainability: 'Sustainability',
      technology: 'Technology',
    },
    businessChallenge: {
      businessChallenge: 'Business Challenge',
      strategicContextMarketForces: '{{brandName}} Strategic Context & Market Forces',
    },
    businessModel: {
      businessModel: 'Business Model',
      howBrandCreatesAndCapturesValue: 'How {{brandName}} creates and captures value',
      keyPartners: 'Key Partners',
      partnerNumber: 'Partner {{number}}',
      primaryModel: 'Primary Model',
      revenueStreams: 'Revenue Streams',
      valueProposition: 'Value Proposition',
    },
    businessOpportunities: {
      businessOpportunities: 'Business Opportunities',
      growthInnovationPathways: '{{brandName}} Growth & Innovation Pathways',
      growthPathwayIofN: 'Growth pathway {{index}} of {{total}}',
    },
    categoryCompetition: {
      categoryCompetition: 'Category & Competition',
      marketPositionCompetitiveLandscape: '{{brandName}} Market Position & Competitive Landscape',
    },
    statistaCharts: {
      coverage: 'Coverage',
      measure: 'Measure',
      published: 'Published',
      seriesTracked: 'Series tracked',
      itemCount_one: '{{count}} item',
      itemCount_other: '{{count}} items',
      measured: 'Statista (measured)',
      modelBased: 'Market Insights (model-based)',
      survey: 'Consumer Insights (survey)',
      smallBase_one: 'Small sample: {{count}} respondent. Treat this figure as indicative.',
      smallBase_other: 'Small sample: {{count}} respondents. Treat this figure as indicative.',
      smallBaseUnknown: 'Small sample. Treat this figure as indicative.',
      viewOnStatista: 'View on Statista',
      chartUnavailable: 'Chart image unavailable',
      chartAlt: 'Statista chart: {{title}}',
    },
    commercialObjective: {
      commercialObjective: 'Commercial Objective',
    },
    companyInformation: {
      companyInformation: 'Company Information',
      companySize: 'Company Size',
      corporateProfileAndLeadership: 'Corporate profile and leadership',
      founded: 'Founded',
      headquarters: 'Headquarters',
      keyLeadership: 'Key Leadership',
      type: 'Type',
    },
    competitiveAnalysis: {
      competitiveAnalysis: 'Competitive Analysis',
      competitors: 'Competitors',
      highThreat: 'High threat',
      lowThreat: 'Low threat',
      mediumThreat: 'Medium threat',
      marketSharesAndRevenueFigures:
        'Market shares and revenue figures are well-researched estimates based on industry analysis',
    },
    competitiveLandscapeAndMarketGrowth: {
      competitiveLandscapeOverview: 'Competitive Landscape Overview',
      marketGrowth: 'Market Growth',
      yearOverYearTrends: 'Year-over-Year Trends',
    },
    competitorDetail: {
      coreStrategy: 'Core Strategy',
      differentiation: 'Differentiation',
      differentiationVs: 'Differentiation vs {{brandName}}',
      marketShare: 'Market Share',
      recentStrategicMoves: 'Recent Strategic Moves',
      strengths: 'Strengths',
      threatLevel: 'Threat level',
      weaknesses: 'Weaknesses',
    },
    corePersona: {
      corePersonas: 'Core Personas',
      loadingPersonas: 'Loading personas…',
    },
    suggestedAudiences: {
      audienceKnowledge: 'Audience knowledge',
      audiencesAreReady: 'The audiences IQ suggested are ready on this report.',
      buildingAudiences:
        'The generation may take a while. You’ll be notified here once it’s finished.',
      newSegment: 'New segment',
      retrying: 'Retrying',
      audienceSavedToKnowledge: '{{name}} is now available in the knowledge hub.',
      couldNotSaveThe: 'Could not save the audience. Please try again.',
      saveToChat: 'Save this audience to chat with it',
      saveToKnowledge: 'Save to knowledge',
      saving: 'Saving',
      someAudiencesCouldNot: 'Some audiences could not be built.',
      thisAudience: 'This audience',
      thisAudienceCouldNot: 'This audience could not be built. Try again from the report.',
      thisAudienceIsStill: 'This audience is still being built. It appears here once it is ready.',
      viewInKnowledgeHub: 'View in knowledge hub',
      tryAgain: 'Try again',
    },
    coreSegments: {
      coreSegments: 'Core Segments',
      selectASegmentToOpenItsFullProfile: 'Select a segment to open its full profile',
    },
    creativeLandscape: {
      aiOverview: 'AI market overview',
      analysis: 'Analysis',
      axisCaption: '{{low}}  \u2190  \u2192  {{high}}',
      brandPositioningAnalysis: 'Brand positioning analysis',
      brands: 'Brands',
      hoverBrandPrompt: 'Hover a brand on the map to see its positioning.',
      brandsAnalysis: 'Brands analysis',
      brandsAnalysisSubtitle: 'Individual brand insights and creative analysis',
      creativeBrandPositioning: 'Creative brand positioning',
      creativeLandscape: 'Creative Landscape',
      creativePersona: 'Creative persona',
      creativeTactics: 'Creative tactics',
      executiveSummary: 'Executive summary',
      funnelStrategy: 'Funnel strategy',
      lowerFunnel: 'Lower funnel',
      moreAxis: 'More {{axis}}:',
      moreCount_one: '(+{{count}} more)',
      moreCount_other: '(+{{count}} more)',
      neutral: 'Neutral',
      noCreativeData: 'No Pathmatics data uploaded',
      noCreativeDataDescription:
        'Upload a Pathmatics export from the data sources panel to see the creative landscape.',
      overviewMeta_one: 'Cross-competitor insights \u00b7 {{count}} brand \u00b7 {{range}}',
      overviewMeta_other: 'Cross-competitor insights \u00b7 {{count}} brands \u00b7 {{range}}',
      overviewMetaNoRange_one: 'Cross-competitor insights \u00b7 {{count}} brand',
      overviewMetaNoRange_other: 'Cross-competitor insights \u00b7 {{count}} brands',
      position: 'Position',
      positioningMap: 'Brand positioning map',
      positioningMapSubtitle: 'Visual representation of brand positioning across the market',
      showBrandAnalysis: 'Show {{brand}} positioning analysis',
      subtitle: 'Creative opportunities for {{brandName}}',
      unreadableData: 'Creative landscape data could not be read',
      unreadableDataDescription:
        'The stored Pathmatics data does not match the expected format. Upload the export again from the data sources panel.',
      upperFunnel: 'Upper funnel',
    },
    culturalAnalysisItems: {
      contentComingSoon: 'Content coming soon...',
      culturalAnalysisItems: 'Cultural Analysis Items',
      culturalTruths: 'Cultural Truths',
      culturalTruthsSubtitle: 'What the brand protects, hides, fights, and could become',
      elephantInTheRoom: 'The Elephant in the Room',
      elephantInTheRoomWarningIcon: 'Elephant In The Room - Warning Icon',
      futureRedefinition: 'Future Redefinition',
      futureRedefinitionRocketIcon: 'Future Redefinition - Rocket Icon',
      prizedPrinciples: 'Prized Principles',
      sacredCows: 'Sacred Cows',
      sacredCowsTrophyIcon: 'Sacred Cows - Trophy Icon',
      surprisingTruths: 'Surprising Truths',
      surprisingTruthsLightbulbIcon: 'Surprising Truths - Lightbulb Icon',
      swornEnemy: 'Sworn Enemy',
      swornEnemySadFaceIcon: 'Sworn Enemy - Sad Face Icon',
      unexpectedEndorser: 'Unexpected Endorser',
      unexpectedEndorserThumbsUpIcon: 'Unexpected Endorser - Thumbs Up Icon',
    },
    culturalSignals: {
      culturalSignals: 'Cultural Signals',
      declining: 'Declining',
      emerging: 'Emerging',
      mainstream: 'Mainstream',
      whereBehavioursAreHeading: 'Where behaviours are heading',
    },
    culturalWhiteSpace: {
      culturalWhiteSpace: 'Cultural White Space',
    },
    cultureContext: {
      culturalLandscapeZeitgeist: '{{brandName}} Cultural Landscape & Zeitgeist',
      culturalMoments: 'Cultural Moments',
      culturalTrends: 'Cultural Trends',
      cultureContext: 'Culture & Context',
      emergingPatternsInCulturalBehavior: 'Emerging patterns in cultural behavior',
      keyMomentsShapingCulturalConversations: 'Key moments shaping cultural conversations',
    },
    currentPerformanceAssessment: {
      areasForImprovement: 'Areas for Improvement',
      currentPerformanceAssessment: 'Current Performance Assessment',
      strengthsToPressAndGapsToClose: 'Strengths to press and gaps to close',
      whatWeReDoingWell: "What We're Doing Well",
    },
    emergingTrends: {
      marketEvolution: 'Market Evolution',
      theseEmergingTrendsAre:
        'These {{count}} emerging trends are reshaping the competitive landscape and creating new opportunities for forward-thinking brands to differentiate and capture market share.',
      emergingTrends: 'Emerging Trends',
      forcesReshapingTheCompetitiveSet: 'Forces reshaping the competitive set',
      trendNumber: 'Trend {{number}}',
    },
    establishedMarketNorms: {
      categoryConventions: 'Category conventions every player follows',
      communication: 'Communication',
      distribution: 'Distribution',
      establishedMarketNorms: 'Established Market Norms',
      innovation: 'Innovation',
      pricing: 'Pricing',
    },
    executiveSnapshot: {
      brandAnalysisOverview: '{{brandName}} Brand Analysis Overview',
      executiveSnapshot: 'Executive Snapshot',
    },
    reportContextHeader: {
      brand: 'Brand',
      reportGoal: 'Report goal',
      targetMarket: 'Target market',
    },
    executiveSummary: {
      executiveSummary: 'Executive Summary',
      marketPositionProfitabilityBrandPosture: 'Market position, profitability, and brand posture',
      moreSources: '+{{count}}',
    },
    failedToLoadAnalysis: 'Failed to load analysis',
    generationalPerspectives: {
      boomer: 'Boomer',
      generationalPerspectives: 'Generational Perspectives',
      genX: 'Gen X',
      genZ: 'Gen Z',
      howEachCohortReadsTheBrand: 'How each cohort reads the brand',
      millennial: 'Millennial',
      readMore: 'Read more',
      socialMovements: 'Social Movements',
      viralMomentsMemes: 'Viral Moments & Memes',
    },
    iqpersonaDetail: {
      chat: 'Chat',
      contentTest: 'Content test',
      focusGroup: 'Focus group',
      iWantToSpeakWith: 'I want to speak with {{personaName}}',
      startNew: 'Start new',
    },
    keyInsight: {
      keyInsight: 'Key Insight',
    },
    marketForces: {
      headwindsAndTailwindsShapingTheCategory: 'Headwinds and tailwinds shaping the category',
      marketForces: 'Market Forces',
      marketHeadwinds: 'Market Headwinds',
      marketTailwinds: 'Market Tailwinds',
    },
    marketingMethodsStrategy: {
      brandApproachChannelsAcquisition: 'Brand approach, channels, and acquisition tactics',
      brandStrategy: 'Brand Strategy',
      customerAcquisition: 'Customer Acquisition',
      marketingMethodsStrategy: 'Marketing Methods & Strategy',
      channelNumber: 'Channel {{number}}',
      primaryMarketingChannels: 'Primary Marketing Channels',
    },
    marketingPerformance: {
      adAwareness: 'Ad Awareness',
      aiInsights: 'AI marketing performance insights',
      aiInsightsSubtitle: 'Strategic observations and recommendations',
      allRegions: 'All regions',
      applyFilters: 'Apply filters',
      attention: 'Attention',
      awareness: 'Awareness',
      bottomOfFunnel: 'Bottom of Funnel',
      brandMetricValue: '{{brand}}: {{value}}',
      brandPerception: 'Brand Perception',
      brandRanking: 'Brand ranking',
      buzz: 'Buzz',
      clearAll: 'Clear all',
      competitorsAverage: 'Competitors Average',
      consideration: 'Consideration',
      currentOwn: 'Current Own',
      dataFilters: 'Data filters',
      endDate: 'End date',
      extendedMetrics: 'Extended brand metrics',
      extendedMetricsSubtitle: 'Compare performance across additional brand metrics',
      formerOwn: 'Former Own',
      funnelStagePerformance: 'Funnel stage competitor performance',
      funnelStageSubtitle: 'Track conversion from awareness to purchase intent',
      impression: 'Impression',
      insightsCoverFullRange:
        'Insights are generated once at upload and cover the full uploaded range, not the current filter.',
      marketingPerformance: 'Marketing Performance',
      metric: 'Metric',
      metricGroup: 'Metric group',
      metricTrends: 'Metric trends over time',
      metricTrendsSubtitle: 'Track how each metric moves over time',
      midFunnel: 'Mid Funnel',
      noDataForFilters: 'No data for the selected filters',
      noDataForFiltersDescription: 'Widen the date range or choose a different region.',
      noDataForMetrics: 'No data for these metrics',
      noDataForMetricsDescription: 'This upload has no scores for any metric in this group.',
      noYougovData: 'No YouGov data uploaded',
      noYougovDataDescription:
        'Upload a YouGov export from the data sources panel to see marketing performance.',
      ownership: 'Ownership',
      purchaseIntent: 'Purchase Intent',
      quality: 'Quality',
      recommend: 'Recommend',
      region: 'Region',
      reputation: 'Reputation',
      satisfaction: 'Satisfaction',
      startDate: 'Start date',
      subtitle: 'Insights for {{brandName}}',
      topOfFunnel: 'Top of Funnel',
      unreadableData: 'Marketing performance data could not be read',
      unreadableDataDescription:
        'The stored YouGov data does not match the expected format. Upload the export again from the data sources panel.',
      value: 'Value',
      wordOfMouth: 'Word of Mouth (WOM)',
    },
    marketWhiteSpace: {
      keyOpportunities: 'Key Opportunities',
      marketWhiteSpace: 'Market White Space',
      untappedOpportunityForGrowthAnd: 'Untapped opportunity for growth and differentiation',
    },
    mediaLandscape: {
      aiOverview: 'AI marketing overview',
      allBrands: 'All brands',
      analyzeBy: 'Analyze by',
      applyFilters: 'Apply filters',
      avgCpm: 'Avg CPM',
      backToSummary: 'Back to summary',
      brandCount: '{{selected}} of {{total}} brands',
      brandCpmOverTime: 'Brand CPM over time',
      brandImpressionsOverTime: 'Brand impressions over time',
      brandMix: 'Brand mix',
      brandName: 'Brand name',
      brandSpendOverTime: 'Brand spend over time',
      carouselRoleDescription: 'carousel',
      change: 'Change',
      channels: 'Channels',
      channelsMixStrategy: 'Channels mix strategy',
      channelsMixSubtitle: 'Spend allocation percentages across brands by channels',
      clearAll: 'Clear all',
      cpmNote: 'CPM is a rate, so it has no mix; each cell is the real cost for that column',
      dataFilters: 'Data filters',
      dimensionColumn: '% {{dimension}}',
      endDate: 'End date',
      flightingStrategy: 'Flighting strategy',
      impressions: 'Impressions',
      insightPosition: '{{position}} / {{count}}',
      keyInsight: 'Key insight',
      keyInsights: 'Key insights',
      marketAverage: 'Mkt avg',
      marketShare: 'Market share',
      mediaLandscape: 'Media Landscape',
      mediaMixStrategy: 'Overall media mix strategy',
      metric: 'Metric',
      metricNounCpm: 'CPM',
      metricNounImpressions: 'impressions',
      metricNounSpend: 'spend',
      mixNote: 'Read horizontally: rows show budget allocation (sum to 100%)',
      nextInsight: 'Next insight',
      noDataForFilters: 'No data for the selected filters',
      noDataForFiltersDescription: 'Widen the date range or select more brands.',
      noPathmaticsData: 'No Pathmatics data uploaded',
      noPathmaticsDataDescription:
        'Upload a Pathmatics export from the data sources panel to see the media landscape.',
      overIndexInsight:
        '{{brand}} puts {{share}} of spend into {{dimension}}, {{multiple}}x the market average of {{marketShare}}.',
      overviewMeta: '{{count}} brands · generated {{generated}}',
      pagedAnnouncement: '{{position}} of {{count}}: {{insight}}',
      previousInsight: 'Previous insight',
      publishers: 'Publishers',
      publishersMixStrategy: 'Publishers mix strategy',
      publishersMixSubtitle: 'Spend allocation percentages across brands by publishers',
      readMore: 'Read more',
      shareNote:
        'Read vertically: columns show each brand share of the full category ({{selected}} of {{total}} advertisers selected)',
      slidePosition: '{{position}} of {{count}}',
      slideRoleDescription: 'slide',
      spendByChannels: 'Spend by brand & channels',
      spendByChannelsSubtitle: 'Breakdown of spend across channels for each brand',
      spendByPublishers: 'Spend by brand & publishers',
      spendByPublishersSubtitle: 'Breakdown of spend across publishers for each brand',
      startDate: 'Start date',
      subtitle: 'Interactive media performance and market trends',
      totalMarket: 'Total market',
      totalSpend: 'Total spend',
      trendInsightCostlier: 'Spend outpaced impressions, pointing to a costlier buy.',
      trendInsightEfficiency: 'Impressions outpaced spend, pointing to a more efficient buy.',
      trendInsightFell:
        '{{brand}} {{metricNoun}} fell {{change}} in {{month}}, its largest month-over-month move in range.',
      trendInsightFlat:
        '{{brand}} {{metricNoun}} held steady in {{month}}, with no month-over-month move of note in range.',
      trendInsightLevel: '{{brand}} {{metricNoun}} stood at {{value}} in {{month}}.',
      trendInsightRose:
        '{{brand}} {{metricNoun}} rose {{change}} in {{month}}, its largest month-over-month move in range.',
      trendInsightTopChannel: 'Led by {{channel}}.',
      trendSubtitle: 'Compare trends across brands over time',
      unreadableData: 'Media landscape data could not be read',
      unreadableDataDescription:
        'The stored Pathmatics data does not match the expected format. Upload the export again from the data sources panel.',
      value: 'Value',
      whiteSpaceOpportunities: 'White space opportunities',
    },
    opportunityCard: {
      expectedImpact: 'Expected Impact',
      feasibility: 'Feasibility',
      keyRisks: 'Key Risks',
      resourcesNeeded: 'Resources Needed',
    },
    peakMomentOfPower: {
      contentComingSoon: 'Content coming soon...',
      peakMomentOfPower: 'Peak Moment of Power',
    },
    priorityPill: {
      priorityLabel: '{{priority}} Priority',
    },
    subculturesAndCommunities: {
      behaviouralGroupsThatCutAcrossTheCoreSegments:
        'Behavioural groups that cut across the core segments',
      contentComingSoon: 'Content coming soon...',
      subCulturesCommunities: 'Sub-cultures & Communities',
    },
    timelyOpportunities: {
      culturalMomentsReadyForActivation: 'Cultural moments ready for activation',
      timelyOpportunities: 'Timely Opportunities',
    },
    topBusinessChallenges: {
      challengeNumber: 'Challenge {{challengeNumber}}',
      theThreeConstraintsOnProfitableGrowth: 'The three constraints on profitable growth',
      topBusinessChallenges: 'Top Business Challenges',
    },
  },
  fourCsWidget: {
    anErrorOccurredWhileGenerating:
      "An error occurred while generating the 4 C's research. Please try again.",
    back: 'Back',
    buildingEachCSequentiallyCategory:
      'Building each C sequentially. Category analysis starting now...',
    continueToSelectTruths: 'Continue to select truths',
    createStrategy: 'Create Strategy',
    createTerritories: 'Create Territories',
    createTerritoriesForTheFollowing:
      'Create territories for the following truths:\n\n{{truthsList}}',
    errorState: {
      anErrorOccurredWhileGenerating:
        'An error occurred while generating the 4 C&apos;s research. Please try again.',
      createStrategy: 'Create Strategy',
      retry: 'Retry',
      somethingWentWrong: 'Something went wrong',
    },
    fourCs: {
      category: 'Category',
      company: 'Company',
      consumer: 'Consumer',
      cultural: 'Cultural',
      findings: 'Findings',
      guidingQuestions: 'Guiding Questions',
      hereAreTheKeyFindings:
        "Here are the key findings from the 4C's: Category, Consumer, Company, and Culture. Review them now, then click 'Continue to select truths' to choose truths to explore when building strategic territories.",
      implications: 'Implications',
      noFindingsFound: 'No findings found',
      noGuidingQuestionsFound: 'No guiding questions found',
      noImplicationsFound: 'No implications found',
      reviewThe4CS: "Review the 4 C's",
    },
    generatingFourCSResearch: "Generating Four C's research...",
    loading: 'Loading...',
    truths: {
      checkCircle: 'Check Circle',
      confidenceScore: 'Confidence Score:',
      insightsValidation: 'Insights Validation',
      noRecommendationsFound: 'No Recommendations found',
      noRedFlagsFound: 'No Red Flags found',
      noSupportingEvidenceFound: 'No Supporting Evidence found',
      pickTheTruthsYouWant:
        'Pick the truths you want to explore when building strategic territories. <br />You may select one, several, or skip this step entirely.',
      recommendations: 'Recommendations',
      recommended: 'Recommended',
      redFlags: 'Red Flags',
      sectionTitle: '{{label}} - {{title}}',
      selectTheTruthsYouWant: 'Select the truths you want to explore further',
      supportingEvidence: 'Supporting Evidence',
    },
  },
  newAnalysis: {
    audience: 'Audience',
    brandGoal: 'Brand & Goal',
    competitors: 'Competitors',
    newIqAnalysis: 'New IQ analysis',
  },
  opportunitiesRoom: {
    opportunitiesKpiStrip: {
      byDurationType: 'By duration type',
      newOpportunities: 'New opportunities',
      sinceYourLastVisit: 'Since your last visit {{lastVisited}}',
      totalOpportunities: 'Total opportunities',
    },
    opportunitiesRoomLayout: {
      about: {
        description:
          'Cultural and social signals, turned into opportunities your brand can act on.',
        openAndAct:
          'Open any opportunity for the full story, then turn it into a brief or export it to share.',
        signalsLandHere:
          'New opportunities land here as they are spotted, grouped by how long the window stays open.',
        title: 'About Opportunities Room',
        trackWhatMatters:
          'Filter by insight type, duration, market or audience, and keep the ones worth watching on your radar list.',
      },
      flashOpportunities: 'Flash Opportunities',
      noOpportunitiesMatchTheCurrent: 'No opportunities match the current filters.',
      opportunitiesRoom: 'Opportunities Room',
      otherOpportunities: 'Other Opportunities',
      rankedByTimeOfGeneration: 'Ranked by time of generation',
      shortFusedOpportunitiesToAct: 'Short fused opportunities to act immediately',
    },
    opportunitiesRoomToolbarDesktop: {
      allAudiences: 'All audiences',
      allDuration: 'All duration',
      allInsights: 'All insights',
      allMarkets: 'All markets',
      searchOpportunities: 'Search opportunities...',
      searchOpportunitiesLabel: 'Search opportunities',
    },
    opportunitiesRoomToolbarMobile: {
      all: 'All',
      activeFilters: 'Open filters, {{activeCount}} active',
      audience: 'Audience',
      durationType: 'Duration type',
      filters: 'Filters',
      insightType: 'Insight type',
      market: 'Market',
      openFilters: 'Open filters',
      radarListOnly: 'Radar list only',
      searchOpportunities: 'Search opportunities...',
      searchOpportunitiesLabel: 'Search opportunities',
      view: 'View',
    },
    opportunityTypesInfoButton: {
      learnAboutOpportunityTypes: 'Learn about opportunity types',
      opportunityTypes: 'Opportunity types',
    },
    radarlistToggle: {
      all: 'All',
      radarList: 'Radar list',
    },
    useOpportunitiesRoom: {
      addedToRadar: 'Opportunity added to radar',
      removedFromRadar: 'Opportunity removed from radar',
    },
  },
  opportunity: {
    durationType: {
      behavioral: {
        description:
          'Lasts 1–3 years. Shifts in how audiences think or act. Early movers build lasting relevance.',
        tags: {
          audienceHabit: 'audience habit',
          channelShift: 'channel shift',
          emergingExpectation: 'emerging expectation',
        },
      },
      evergreen: {
        description:
          'Lasting, indefinitely relevant. Not tied to a moment, ignoring it is a strategic risk.',
        tags: {
          categoryTruth: 'category truth',
          coreBehavior: 'core behavior',
          fundamentalNeed: 'fundamental need',
        },
      },
      flash: {
        description:
          'Lasts days to a few weeks. Momentum-driven, fades fast. Missing it rarely causes lasting damage.',
        tags: {
          meme: 'meme',
          newsHook: 'news hook',
          viralMoment: 'viral moment',
        },
      },
      seasonal: {
        description:
          'Lasts weeks to months. Recurring or time-boxed. Predictable enough to plan campaigns around.',
        tags: {
          culturalMoment: 'cultural moment',
          eventDriven: 'event-driven',
          quarterlyCycle: 'quarterly cycle',
        },
      },
    },
    insightType: {
      brandProduct: 'Brand/Product',
      competition: 'Competition',
      performance: 'Performance',
      social: 'Social',
      strategic: 'Strategic',
    },
    opportunitiesCardV2: {
      addToFavorites: 'Add to favorites',
      addToRadar: 'Add to radar',
      audience: 'Audience',
      dateOfGeneration: 'Date of generation',
      durationType: 'Duration type',
      insightType: 'Insight type',
      moreActions: 'More actions',
      new: 'New',
      noAudienceMatch: 'No audience match',
      notDefined: 'Not defined',
      ourAiCouldnTAccurately: "Our AI couldn't accurately infer the content",
      region: 'Region',
      removeFromFavorites: 'Remove from favorites',
      removeFromRadar: 'Remove from radar',
      thisOpportunityDoesnTMatch: "This opportunity doesn't match your current audience segments.",
      viewOpportunityDetail: 'View opportunity detail',
    },
    opportunityDetailOverlay: {
      closeOverlay: 'Close overlay',
      next: 'Next',
      nextOpportunity: 'Next opportunity',
      opportunityActions: 'Opportunity actions',
      opportunityDetail: 'Opportunity detail',
      previous: 'Previous',
      previousOpportunity: 'Previous opportunity',
    },
    opportunityOverlayToolbar: {
      addToRadar: 'Add to radar',
      downloadOpportunity: 'Download Opportunity',
      exportingYourPdfThisMight: 'Exporting your PDF. This might take a few seconds',
      failedToDownloadPdfPlease: 'Failed to download PDF. Please try again.',
      newBrief: 'New Brief',
      removeFromRadar: 'Remove from radar',
      saveToProject: 'Save to project',
      startBrief: 'Start Brief',
    },
  },
  socialMediaOpportunitiesWidget: {
    opportunityDetail: {
      audience: 'Audience',
      close: 'Close',
      confidence: {
        negative: 'Negative',
        neutral: 'Neutral',
        positive: 'Positive',
      },
      insightType: 'Insight Type',
      noOpportunitySelected: 'No opportunity selected',
      region: 'Region',
    },
    brandMentionsSection: {
      dataSourcesThatInformedThis: 'Data sources that informed this opportunity',
      morePosts: 'More Posts ({{remainingCount}} more)',
      sources: 'Sources',
      viewSource: 'View source',
    },
    brandMentionsSectionV1: {
      morePosts: 'More Posts ({{remainingCount}} more)',
      brandMentions: 'Brand Mentions',
      checkCircle: 'Check Circle',
      topVoices: 'Top Voices',
    },
    durationTypeCard: {
      durationOpportunity: '{{durationLabel}} Opportunity',
      recommendedTimeframe: 'Recommended timeframe',
    },
    durationTypeConfig: {
      behavioral: 'Behavioral',
      evergreen: 'Evergreen',
      flash: 'Flash',
      seasonal: 'Seasonal',
    },
    emptyStates: {
      allYourFavoriteOpportunitiesWill:
        'All your favorite opportunities will be displayed here once you add them',
      noFavoriteOpportunityAddedYet: 'No favorite opportunity added yet',
      noOpportunityGeneratedRecently: 'No opportunity generated recently',
      opportunitiesWillAppearHereAs: 'Opportunities will appear here as you engage with agents',
    },
    howToRespond: {
      howToRespond: 'How to respond',
      message: 'Message',
      suggestedByIdeationTool: 'Suggested by Ideation Tool',
      suggestedChannels: 'Suggested channels',
      thoughtStarters: 'Thought starters',
    },
    ideationCard: {
      provocation: 'Provocation',
    },
    opportunitiesFilter: {
      all: 'All',
      audience: 'Audience',
      clearFilters: 'Clear filters',
      favorites: 'Favorites',
      filterByTargetAudience: 'Filter by target audience',
      removeAudience: 'Remove {{audience}} filter',
      trendingOpportunities: 'Trending Opportunities',
    },
    opportunitiesGrid: {
      allYourFavoriteOpportunitiesWill:
        'All your favorite opportunities will appear here once you add them.',
      noFavoriteOpportunities: 'No favorite opportunities',
      noOpportunitiesToDisplay: 'No opportunities to display',
      noOpportunityMatchesYourFilters: 'No opportunity matches your filters applied',
      ourAiAgentsCouldnT:
        "Our AI agents couldn't spot any relevant opportunity for your brand until this moment. Try visiting later.",
      tryApplyingDifferentFiltersOr: 'Try applying different filters or clear filters',
    },
    opportunitiesList: {
      otherOpportunities: 'Other Opportunities',
      topOpportunities: 'Top Opportunities',
    },
    opportunityDetailV1: {
      audience: 'Audience',
      iDLikeToGetYour:
        "I'd like to get your perspective on the opportunity titled {{opportunityTitle}}",
      noOpportunitySelected: 'No opportunity selected',
    },
    opportunityDetailV2: {
      audience: 'Audience',
      close: 'Close',
      insightType: 'Insight Type',
      iWantToSpeakWith: 'I want to speak with {{persona}}',
      noOpportunitySelected: 'No opportunity selected',
      region: 'Region',
    },
    potentialImpactCard: {
      noPredictedOutcomeAvailable: 'No predicted outcome available.',
      potentialImpact: 'Potential Impact',
    },
    socialMediaOpportunitiesThumbnail: {
      opportunities: 'Opportunities',
    },
    suggestedChannelCard: {
      source: 'Source: {{platform}}',
    },
    trendMetrics: {
      engagementTotal: 'Engagement Total',
      theOverallNumberOfInteractions:
        'The overall number of interactions (likes, comments, shares, reposts) a trend has generated across platforms.',
    },
    trendSummary: {
      checkCircle: 'Check Circle',
      trend: 'Trend',
      trendInsight: 'Trend Insight',
      trendSummary: 'Trend Summary',
    },
    useCreateBrief: {
      createASocialMediaBrief:
        'Create a social media brief for the opportunity named "{{opportunityTitle}}"',
    },
    useOpportunityFilters: {
      uncategorized: 'Uncategorized',
    },
    useOpportunityHeaderConfig: {
      back: 'Back',
      downloadOpportunity: 'Download Opportunity',
      generateBrief: 'Generate Brief',
      opportunities: 'Opportunities',
    },
    whyItMatters: {
      whyItMatters: 'Why it matters',
      whyItMattersFor: 'Why it matters for {{brandName}}',
    },
    whyItMattersV1: {
      brandImpact: 'Brand Impact',
      checkCircle: 'Check Circle',
      knowledgeBases: 'Knowledge Bases',
      reasoningForHighlightingTheOpportunity:
        'Reasoning for highlighting the opportunity, accounting for engagement sentiment, trending status, audience reach, and topic relevance and recency.',
      whyThisMatters: 'Why this matters',
      whyThisMattersFor: 'Why this matters for {{brandName}}',
    },
  },
  strategicTerritoriesWidget: {
    back: 'Back',
    continueWithTerritoryTitled:
      'Continue with territory titled "{{title}}" for strategy generation.',
    downloadStrategicTerritory: 'Download Strategic Territory',
    failedToDownloadStrategicTerritory: 'Failed to download strategic territory',
    generatingStrategicTerritories: 'Generating strategic territories...',
    preparingYourDownloadThisMay: 'Preparing your download, this may take a moment…',
    ratingsDisplay: {
      breakthroughPotential: 'Breakthrough potential',
      inspirationalPotential: 'Inspirational potential',
      strategicAlignment: 'Strategic alignment',
    },
    saveTerritoryToProject: 'Save territory to project',
    selectATerritoryToExplore: 'Select a territory to explore',
    selectTerritory: 'Select Territory',
    startABrief: 'Start a brief',
    strategicTerritories: 'Strategic Territories',
    strategicTerritoriesThumbnail: {
      recommended: 'Recommended',
    },
    strategy: 'Strategy',
    territoryCard: {
      exploreTerritory: 'Explore Territory',
      recommended: 'Recommended',
    },
    territoryDetail: {
      audience: 'Audience',
      coreTensions: 'Core tensions',
      getWhoToBy: 'Get / Who / To / By',
      keyMessage: 'Key message',
      nextTerritory: 'Next territory',
      previousTerritory: 'Previous territory',
      recommended: 'Recommended',
      territory: 'Territory',
      thePillars: 'The pillars',
      validationAndMeasurement: 'Validation and measurement',
    },
    thisMayTakeAMoment: 'This may take a moment as we analyze the validated truths',
  },
} as const;
